<div style="height: 100%; overflow-y: auto">
  <div
    [ngStyle]="contentConfigStyle"
    id="sumsub-websdk-container"
    class="text-center element-zoom custom-side-padding custom-padding-top pointer-events-none mt-3"
  ></div>
  <div
    *ngIf="showApplicationCompleteMessage"
    class="form-group pointer-events-none ml-2 mr-2"
    style="margin-bottom: 10px; text-align: center"
  >
    <span
      [innerHTML]="
        (renderedContent | safeHtml) ??
        'Please wait while we process your application. You will be redirected once your application has been approved.'
      "
    ></span>
  </div>
</div>
